// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"08059f29","378":"56dea511","488":"97bc9602","560":"5adef9bb"}[chunkId] + ".chunk.js";
};